<!-- 修改首页 -->
<template>
  <div class="index">
    <div class="home-container">
      <!-- 标题 -->
      <p class="home-title">南昌县退役军人智慧服务</p>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.path" class="banner" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="tabbar-list">
      <div
        class="tabbar-item"
        v-for="(item, index) in tabbar"
        :key="index"
        @click="navGo(item.url)"
      >
        <img class="tabbar-icon" :src="item.icon" />
        <p>{{ item.name }}</p>
      </div>
    </div>
    <List />
  </div>
</template>
<script>
import { getBanner } from "@/api/apiData";
import List from "../ideology/ideology";
import { mapState } from "vuex";
export default {
  components: { List },

  // inject: ['Token'],
  data() {
    return {
      bannerList: [],
      type: 1,
      tabbar: [
        {
          name: "就业创业",
          icon: require("@/components/tabBar/img/home.png"),
          url: "Home",
        },
        {
          name: "在线办事",
          icon: require("@/components/tabBar/img/icon03.png"),
          url:
            "https://ncxtyjrwork.nccloudmedia.com/index.php/Approval/Guide/index",
        },
        {
          name: "政策法规",
          icon: require("@/components/tabBar/img/interpretation.png"),
          url: "Interpretation",
        },
        {
          name: "八一讲堂",
          icon: require("@/components/tabBar/img/Ideology.png"),
          url: "Ideology",
        },
         {
          name: "生活服务",
          icon: require("@/components/tabBar/img/life.png"),
          url: "Life",
        },
      ],
    };
  },
  computed: {
    ...mapState(["loginType"]),
  },
  methods: {
    navGo(url) {
      if (
        url ==
        "https://ncxtyjrwork.nccloudmedia.com/index.php/Approval/Guide/index"
      ) {
        window.location.href = url;
      } else {
        this.$router.push({
          name: url,
        });
      }
    },
    // 获取首页轮播图
    getBannerList() {
      var that = this;
      getBanner().then((res) => {
        // //(res);
        if (res.code == 1) {
          that.bannerList = res.data;
        }
      });
    },
  },
  created() {

  },
  mounted() {
    if (this.loginType == 2) {
      this.$router.replace({
        name: "HomeBoss",
      });
    }
    // this.Token();
    this.getBannerList();
  },
};
</script>
<style lang='less' scoped>
.index {
  background: #f7f7f7;
}
.home-container {
  background: #fff;
  padding: 0 0.32rem;
  // 标题
  .home-title {
    position: fixed;
    width: 100%;
    z-index: 10;
    padding: 0.18rem 0;
    top: 0;
    left: 0;
    font-size: 0.32rem;
    font-weight: bold;
    line-height: 0.45rem;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    background: #fff;
  }
  // 轮播图
  .my-swipe {
    margin-top: 0.8rem;
    padding: 0.2rem 0;
    .van-swipe-item {
      .banner {
        width: 100%;
        height: 2.6rem;
        display: block;
        border-radius: 0.16rem;
      }
    }
  }
}
.tabbar-list {
  background: #fff;
  padding: 0.37rem 5%;
  margin: 0.2rem auto;
  display: flex;
  align-items: center;
  // flex-wrap: wrap;
  .tabbar-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 25%;
    font-size: 0.22rem;
    font-weight: bold;
    line-height: 1.5;
    color: rgba(255, 67, 67, 1);
    .tabbar-icon {
      width: 0.48rem;
      height: 0.48rem;
    }
  }
}
</style>